import { VACANCY_STATUS_MODEL } from '@widgets/vacancy/vacancyStatus/constants';

export const VACANCY_STATUS_DISABLED_STATUS = [VACANCY_STATUS_MODEL.ARCHIVED];
